import React, { useState } from 'react';
import {
    GetFilteredYards_getFilteredYards as Yard,
    GetAllRegions_getAllRegions as RegionType
} from '../../types/schemaTypes';
import './Yards.scss';
import DeleteModal from '../JobProfile/DeleteModal/DeleteModal';

interface Option {
    id: number | string;
    name: string | number;
}

interface YardItemProps {
    yard: Yard;
    regionsWithDistricts: RegionType[];
    index: number;
    canEditYards: boolean;
    canDeleteYards: boolean;
    onEditClick: (yard: Yard) => void;
    onDelete?: (record: any) => void;
    onClickYard: (lat: number, lng: number, yardName: string) => void;
}

const YardItem = ({
    yard,
    regionsWithDistricts,
    index,
    onEditClick,
    onDelete,
    canEditYards,
    canDeleteYards,
    onClickYard,
}: YardItemProps): React.ReactElement => {
    const isEditYardsEnabled = canEditYards;
    const isDeleteYardsEnabled = canDeleteYards;

    const { yardName, yardType, addressStreet, city, regionId, districtId, zip, latitude, longitude } = yard;
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const isOdd = index % 2 == 1;
    const containerStyle = `LofasItem-Bottom-Container ${!isOdd && 'LofasItem-Bottom-Container-With-Background'}`;
    const handleDelete = () => {
        onDelete && onDelete(yard);
        setDeleteConfirm(false);
    };

    const regionWithDistricts = regionsWithDistricts.find(region => region.id === regionId);
    const region = regionWithDistricts?.regionName ?? '';
    const district = regionWithDistricts?.districts?.find(district => district?.id === districtId)?.districtName ?? '';

    return (
        <div className={containerStyle}>
            <div
                className="Yards-List-Header-Link"
                onClick={(): void => onClickYard(latitude!, longitude!, yardName!)}
            >
                {yardName}
            </div>
            <div className="Yards-List-Header-Lg">{yardType}</div>
            <div className="Yards-List-Header-Lg">{addressStreet}</div>
            <div className="Yards-List-Header">{city}</div>
            <div className="Yards-List-Header">{region}</div>
            <div className="Yards-List-Header">{district}</div>
            <div className="Yards-List-Header-Sm">{zip}</div>
            <div className="GridViewItem-List-Header">
                {isEditYardsEnabled && (
                    <div className="GridViewItem-Edit-Container" onClick={() => onEditClick(yard)}>
                        <i className="material-icons UsersItem-Icon">edit</i>
                        <span className="UsersItem-Link">Edit</span>
                    </div>
                )}
                {isEditYardsEnabled && isDeleteYardsEnabled && <>&nbsp;|&nbsp;</>}
                {isDeleteYardsEnabled && (
                    <div className="GridViewItem-Edit-Container" onClick={() => setDeleteConfirm(true)}>
                        <i className="material-icons UsersItem-Icon">delete</i>
                        <span className="UsersItem-Link">Delete</span>
                    </div>
                )}
            </div>

            <DeleteModal
                show={deleteConfirm}
                name={'yard'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default YardItem;

